import React, { useEffect } from "react";
import "./Terms_Conditions.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTerms_and_Conditions } from "../../features/terms_conditions.js/Slice";
import parse from "html-react-parser";

function Terms_Conditions() {
  const navigate = useNavigate();

  const termsconditions = useSelector(
    (state) => state.termsconditions.termsconditions,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTerms_and_Conditions());
  }, []);

  return (
    <section className="privacy-section">
      <div className="top-bar" onClick={() => navigate("/")}>
        <div className="container">
          <span className="back-text">BACK</span>
        </div>
      </div>

      <div className="privacy-header">
        <div className="container">
          <h1 className=" main_head">Terms and Conditions</h1>
        </div>
      </div>

      <div className="container">
        <div className="privacy-card">
            {termsconditions?.content ? parse(termsconditions?.content) : ""}
          {/* {termsconditions?.data?.map((pp) => (
            <p className="dark_black_text">{parse(pp.content)}</p>
          ))} */}

          {/* <div className="privacy-buttons">
            <button className="accept-btn">Accept</button>
            <button className="decline-btn">Decline</button>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Terms_Conditions;
